import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const wrapper = css`
  display: flex;
  align-items: stretch;
  margin: 0 0 20px;

  &#delayed {
    border-left: 10px solid ${colors.error.default};
  }

  &#warning {
    border-left: 10px solid ${colors.warning.default};
  }

  &#onTime {
    border-left: 10px solid ${colors.primary.default};
  }
`;

export const header = css`
  margin: 0 0 10px 0px;
  min-width: 400px;
  display: flex;
`;

const left = css`
  display: flex;
  width: 80%;
`;

export const leftContainer = css`
  ${left}
  flex-direction: column;
  align-items: stretch;
  min-width: 400px;
`;

export const headerTitles = css`
  ${left}

  > span {
    width: 25%;
    padding: 0 10px;

    :first-child {
      max-width: 80px;
    }

    :nth-child(2) {
      padding-left: 0px;
    }
  }
`;

export const right = css`
  width: 20%;
  min-width: 222px;
`;

export const markAsDoneWrapper = css`
  ${right}
  border: 1px solid ${colors.gray.light};
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const reminderRow = css`
  display: flex;
  flex-grow: 1;
  border-top: 1px solid ${colors.gray.light};

  :last-child {
    border-bottom: 1px solid ${colors.gray.light};
  }
`;

export const column = css`
  width: 25%;
  padding: 20px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > span {
    display: block;
  }
`;

export const iconColumn = css`
  ${column}
  width: 72px;
  align-items: center;
`;

export const vehicleColumn = css`
  ${column}
  padding: 20px 10px 20px 0;
`;

export const nextRevisionColumn = css`
  ${column}
  padding-right: 20px;
`;

export const licensePlate = css`
  margin: 0 0 10px;
`;

export const progress = css`
  height: 5px;
  background: ${colors.gray.light};
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  margin: 10px 0 5px;

  > span {
    display: block;
    height: 100%;
    border-radius: 3px;
  }

  > #delayed {
    background-color: ${colors.error.default};
  }

  > #warning {
    background-color: ${colors.warning.default};
  }

  > #onTime {
    background-color: ${colors.primary.default};
  }
`;

export const nextMaintenance = css`
  color: ${colors.gray.default};
  font-weight: ${fonts.weight.bold};
  font-size: ${fonts.size.smallest};
  line-height: 17px;

  &#delayed {
    display: flex;
    color: ${colors.error.default};
  }

  > svg {
    font-size: 16px;
    margin-right: 5px;
  }
`;

export const revisionName = css`
  > span {
    word-break: break-word;
  }
`;
